import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

// Schemas
const manualGooglePlaceDetailSchema = Yup.object().shape({
  address1: Yup.string().required(i18n.t('manual_address.address1_required')),
  city: Yup.string()
    .matches(/^[A-Za-z0-9\s.,'&-]+$/, i18n.t('manual_address.city_validation'))
    .required(i18n.t('manual_address.city_required')),
  region: Yup.string()
    .matches(/^[A-Za-z]{2}$/, i18n.t('manual_address.region_validation'))
    .required(i18n.t('manual_address.region_required')),
  postalCode: Yup.string()
    .matches(/^\d{5}$/, i18n.t('manual_address.postalCode_validation'))
    .required(i18n.t('manual_address.postalCode_required')),
  country: Yup.string()
    .matches(/^[A-Za-z\s.]+$/, i18n.t('manual_address.country_validation'))
    .required(i18n.t('manual_address.country_required'))
});

// Types
export type ManualGooglePlaceData = Yup.InferType<typeof manualGooglePlaceDetailSchema>;

// Resolvers
export const manualGooglePlaceDetailResolver = yupResolver(manualGooglePlaceDetailSchema);
